/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EmailChangeDoneResponseParser = 
/* #__PURE__ */ parsers.object([['email', codecString]]);
export class EmailChangeDoneResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EmailChangeDoneResponseParser.decode(input).map(res => new EmailChangeDoneResponse(res));
    }
    static unsafeDecode(input) {
        return EmailChangeDoneResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EmailChangeDoneResponseParser.encode(data);
    }
    static schema() {
        return EmailChangeDoneResponseParser.schema();
    }
}
